export const QUOTE_REQUEST = 'quotes/QUOTE_REQUEST';

// Create
export const CREATE_QUOTE_SUCCESS = 'quotes/CREATE_QUOTE_SUCCESS';
export const CREATE_QUOTE_FAILURE = 'quotes/CREATE_QUOTE_FAILURE';

// Read
export const GET_ALL_QUOTES_SUCCESS = 'quotes/GET_ALL_QUOTES_SUCCESS';
export const GET_ALL_QUOTES_FAILURE = 'quotes/GET_ALL_QUOTES_FAILURE';

// Update
export const UPDATE_QUOTE_SUCCESS = 'quotes/UPDATE_QUOTE_SUCCESS';
export const UPDATE_QUOTE_FAILURE = 'quotes/UPDATE_QUOTE_FAILURE';

// Delete
export const DELETE_QUOTE_SUCCESS = 'quotes/DELETE_QUOTE_SUCCESS';
export const DELETE_QUOTE_FAILURE = 'quotes/DELETE_QUOTE_FAILURE';
